/* eslint-disable react/sort-comp */
/* eslint-disable import/prefer-default-export */
import React, { Component } from 'react';
import {
  ModalBody,
  ModalFooter,
  ModalHeader,
  FormGroup,
  ComposedModal,
  TextArea,
  TimePicker,
  DatePicker,
  DatePickerInput,
  Button,
  DataTable,
  Table,
  TableHeader,
  TableHead,
  TableRow,
  TableContainer,
  TableBody,
  TableCell,
  Tile,
  TableToolbar,
  TableToolbarContent,
  TextInput,
  Loading,
} from 'carbon-components-react';
import moment from 'moment';
import Edit16 from '@carbon/icons-react/lib/edit/16';
import Add16 from '@carbon/icons-react/lib/add/16';
import Save16 from '@carbon/icons-react/lib/save/16';
import SimpleReactValidator from 'simple-react-validator';
import Delete16 from '@carbon/icons-react/lib/delete/16';
import Email16 from '@carbon/icons-react/lib/email/16';
import { NoRecordsPlaceholder } from '../../../helpers/jsonschemaform/DataTableExtention';
import { IsInRole } from '../../../helpers/authorization/Policies';
import { entitiesLabels } from '../../../helpers/Constants';
import { showNotification } from '../../../helpers/notification/BaseNotification';
import EmailChips from '../../../helpers/EmailChips';
import DateTimePicker from '../../../helpers/DateTimePicker';
import { AppContext } from '../../../helpers/context/AppContext';

export class InspectionNotification extends Component {
  notificaFormProps = () => ({});

  inspectionNotificationFormProp = () => ({
    id: null,
    distributionList: null,
    responsibleEmail: null,
  });

  inspectionNotificationFormDocumentProps = () => ({
    id: null,
    name: null,
  });

  inspectionReportActivityProps = () => ({
    id: null,
    activity: null,
    inspector: null,
    date: null,
    to: null,
    from: null,
  });

  constructor(props) {
    super(props);

    this.validationsActivity = new SimpleReactValidator({
      validators: {
        time: {
          message: ':attribute must be a valid time',
          rule: (val, params, validator) =>
            validator.helpers.testRegex(val, /^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]+$/) &&
            params.indexOf(val) === -1,
          required: true, // optional
        },
      },
    });
    this.validatorTime = new SimpleReactValidator({ locale: 'en' });
    this.validationsDocuments = new SimpleReactValidator();
    this.validationsNotifications = new SimpleReactValidator();

    // var a = this.props.inspectionInfo.inspectionReport.notificationForm;
    this.state = {
      inspectionNotificationFormModel: {
        ...this.inspectionNotificationFormModel,
        distributionList: this.props.notificationForm.distributionList,
        responsibleEmail: this.props.notificationForm.responsibleEmail,
      },
      inspectionNotificationFormDocumentModel: {
        ...this.inspectionNotificationFormDocumentProps(),
      },
      inspectionReportActivityModel: {
        ...this.inspectionReportActivityProps(),
      },
      flagTime: false,
      isOpenModalActivity: false,
      isOpenModalDocuments: false,
      documents: [],
      notificationForm: this.props.notificationForm,
      activities: [],
      isSubmitted: false,
      //RITM0960566 - Inspection Report Problem Fix
      //isDisabledSend: true,
      //End
    };
    this.showModalActivity = this.showModalActivity.bind(this);
    this.showModalDocument = this.showModalDocument.bind(this);
    this.updateState = this.updateState.bind(this);
    this.addDocuments = this.addDocuments.bind(this);
    this.addActivities = this.addActivities.bind(this);
    this.deleteDocuments = this.deleteDocuments.bind(this);
    this.deletedeleteActivities = this.deletedeleteActivities.bind(this);
    this.updateDocuments = this.updateDocuments.bind(this);
    this.updateActivity = this.updateActivity.bind(this);
    this.onActivityDateChange = this.onActivityDateChange.bind(this);
    this.updateDistributionList = this.updateDistributionList.bind(this);
  }

  componentDidMount() {}

  renderLoadingModal = () => {
    const show = this.state.isSubmitted;
    return show && <Loading active withOverlay description="Saving..." />;
  };

  showModalActivity() {
    this.setState({
      inspectionReportActivityModel: {
        ...this.inspectionReportActivityProps(),
      },
    });
    this.setState((oldState) => ({ isOpenModalActivity: !oldState.isOpenModalActivity }));
  }

  showModalDocument() {
    this.setState((oldState) => ({ isOpenModalDocuments: !oldState.isOpenModalDocuments }));
    this.setState({
      inspectionNotificationFormDocumentModel: {
        ...this.inspectionNotificationFormDocumentProps(),
      },
    });
  }

  // ////FUNZIONI

  saveNotificationForm = () => {
    const notification = this.state.inspectionNotificationFormModel;
    if (this.validationsNotifications.allValid()) {
      this.props.saveNotificationForm(notification);
      //RITM0960566 - Inspection Report Problem Fix
      //this.setState({
      //  isDisabledSend: false,
      //});
      //End
    } else {
      this.validationsNotifications.showMessages();
      showNotification.warning(
        `${entitiesLabels.WARNING}`,
        ` ${entitiesLabels.NOTIFICATION} required fields are missing  `
      );
      this.forceUpdate();
    }
  };

  sendNotification = () => {
    if (this.validationsNotifications.allValid()) {
      const notification = this.state.inspectionNotificationFormModel;
      this.props.sendNotification(notification);
    } else {
      this.validationsNotifications.showMessages();
      showNotification.warning(
        `${entitiesLabels.WARNING}`,
        `${entitiesLabels.NOTIFICATION} required fields are missing  `
      );
      this.forceUpdate();
    }
  };

  updateDistributionList = (inputName, inputValue, objName) => {
    this.props.notificationForm.distributionList = inputValue;
    this.updateState(inputName, inputValue, objName);
  };

  updateStatesTime = (inputName, inputValue, objName) => {
    if (inputValue == false) {
      this.setState({ flagTime: true });
      if (!this.validatorTime.allValid()) {
        this.validatorTime.showMessages();
      }
    } else {
      const statusCopy = { ...this.state };
      statusCopy[objName][inputName] = inputValue;
      statusCopy.flagTime = false;
      this.setState(statusCopy);
    }
  };

  updateState = (inputName, inputValue, objName) => {
    const statusCopy = { ...this.state };
    statusCopy[objName][inputName] = inputValue;
    this.setState(statusCopy);
  };

  handleChangeModelNotificationForm = (el) => {
    const inputName = el.target.name;
    const inputValue = el.target.value;
    this.updateState(inputName, inputValue, 'inspectionNotificationFormModel');
  };

  handleChangeModelActivity = (el) => {
    const inputName = el.target.name;
    const inputValue = el.target.value;
    const objName = 'inspectionReportActivityModel';
    this.updateState(inputName, inputValue, objName);
  };

  handleChangeModelDocuments = (el) => {
    const inputName = el.target.name;
    const inputValue = el.target.value;
    const objName = 'inspectionNotificationFormDocumentModel';
    this.updateState(inputName, inputValue, objName);
  };

  // //DATEPIKER

  onActivityDateChange(e) {
    this.setState((prevState) => {
      const inspectionReportActivityModel = { ...prevState.inspectionReportActivityModel };
      inspectionReportActivityModel.date = moment(e[0]).format('YYYY-MM-DD');
      return { inspectionReportActivityModel };
    });
  }

  // //ACTIVITY
  addActivities = () => {
    if (this.validationsActivity.allValid()) {
      if (!this.validatorTime.allValid()) {
        if (this.state.inspectionReportActivityModel.id == null) {
          this.setState(
            {
              activities: this.state.activities.concat(this.state.inspectionReportActivityModel),
              notificationForm: {
                ...this.state.notificationForm,
                activities: this.state.notificationForm.activities.concat(
                  this.state.inspectionReportActivityModel
                ),
              },
            },
            this.props.addActivity(this.state.inspectionReportActivityModel)
          );

          this.setState({
            inspectionReportActivityModel: {
              ...this.inspectionReportActivityProps(),
            },
          });
        } else {
          this.props.addActivity(this.state.inspectionReportActivityModel);
          this.setState({
            inspectionReportActivityModel: {
              id: null,
              activity: null,
              inspector: null,
              date: null,
              to: null,
              from: null,
            },
          });
        }
        this.showModalActivity();
      } else {
        this.validator.showMessages();
        showNotification.warning(
          `${entitiesLabels.WARNING}`,
          `${entitiesLabels.INSPECTION} Time is invalid `
        );
        this.forceUpdate();
      }
    } else {
      this.validationsActivity.showMessages();
      showNotification.warning(
        `${entitiesLabels.WARNING}`,
        ` ${entitiesLabels.ACTIVITY} required fields are missing  `
      );
      this.forceUpdate();
    }
  };

  deletedeleteActivities = (id) => {
    const activity = this.state.notificationForm.activities.filter((x) => x.id != id);
    this.setState(
      {
        notificationForm: {
          ...this.state.notificationForm,
          activities: activity,
        },
      },
      this.props.deleteActivity(id)
    );
  };

  updateActivity = (id) => {
    this.setState((prevState) => {
      const copy = { ...prevState.inspectionReportActivityModel };
      const activities = this.props.notificationForm.activities.filter(
        (document) => document.id == id
      );
      copy.activity = activities[0].activity;
      copy.inspector = activities[0].inspector;
      copy.from = activities[0].from;
      copy.to = activities[0].to;
      copy.date = activities[0].date;
      copy.id = activities[0].id;
      this.setState({ inspectionReportActivityModel: copy });
    });

    this.showModalActivity();
  };

  // ////DOCUMENT
  addDocuments = () => {
    if (this.validationsDocuments.allValid()) {
      if (this.state.inspectionNotificationFormDocumentModel.id == null) {
        this.setState({
          documents: this.state.documents.concat(
            this.state.inspectionNotificationFormDocumentModel
          ),
        });
        this.props.addDocument(this.state.inspectionNotificationFormDocumentModel);
        this.setState({
          inspectionNotificationFormDocumentModel: {
            id: null,
            name: null,
          },
        });
      } else {
        this.props.addDocument(this.state.inspectionNotificationFormDocumentModel);
        this.setState({
          inspectionNotificationFormDocumentModel: {
            id: null,
            name: null,
          },
        });
      }
      this.showModalDocument();
    } else {
      this.validationsDocuments.showMessages();
      showNotification.warning(
        `${entitiesLabels.WARNING}`,
        `${entitiesLabels.DOCUMENTS} required fields are missing  `
      );

      this.forceUpdate();
    }
  };

  updateDocuments = (id) => {
    this.setState((prevState) => {
      const copy = { ...prevState.inspectionNotificationFormDocumentModel };
      const documents = this.props.notificationForm.documents.filter(
        (document) => document.id == id
      );
      copy.name = documents[0].name;
      copy.id = documents[0].id;
      this.setState({ inspectionNotificationFormDocumentModel: copy });
    });

    this.showModalDocument();
  };

  deleteDocuments = (id) => {
    this.props.deleteDocument(id);
  };

  // //RENDER MODALI
  newActivity() {
    const validationsTime = {
        validTime: this.validatorTime.message('validTime', this.state.flagTime, 'accepted'),
    };
    let diffFromTo = false;
    if (this.state.inspectionReportActivityModel.to != null) {
      const timeEnd = moment(this.state.inspectionReportActivityModel.to, 'HH:mm a');
      const timeStart = moment(this.state.inspectionReportActivityModel.from, 'HH:mm a');
      const duration = moment.duration(timeEnd.diff(timeStart));
      const minutes = parseInt(duration.asMinutes()) % 60;
      const hours = parseInt(duration.asHours());
      if (minutes >= 0 && hours >= 0) diffFromTo = true;
    }
    const validationsActivity = {
      inspector: this.validationsActivity.message(
        'Inspector',
        this.state.inspectionReportActivityModel.inspector,
        'required',
        (this.validator = new SimpleReactValidator({
          messages: {
            required: 'the :attribute field is required',
          },
        }))
      ),
      date: this.validationsActivity.message(
        'Date',
        this.state.inspectionReportActivityModel.date,
        'required',
        (this.validator = new SimpleReactValidator({
          messages: {
            required: 'the :attribute field is required',
          },
        }))
      ),
      from: this.validationsActivity.message(
        'From',
        this.state.inspectionReportActivityModel.from,
        'required'
      ),
      to: this.validationsActivity.message(
        'To',
        this.state.inspectionReportActivityModel.to,
        'required'
      ),
      activity: this.validationsActivity.message(
        'Activity',
        this.state.inspectionReportActivityModel.activity,
        'required'
      ),
      diffTIme: this.validationsActivity.message('diffTIme', diffFromTo, 'accepted'),
    };
    const modalHeader = {
      title: this.props.isEditModal ? 'Edit ' : 'Add new ',
      iconDescription: 'Close',
      buttonOnClick: () => this.showModalActivity(),
    };
    return (
      <>
        <ComposedModal
          className="light-modal"
          open={this.state.isOpenModalActivity}
          danger="false"
          onClose={() => false}
        >
          <ModalHeader className="margin-modal" {...modalHeader}>
            <p />
          </ModalHeader>
          <ModalBody className="margin-modal">
            <div className="bx--grid--full-width">
              <div className="bx--row">
                <div className="bx--row">
                  <div className="bx--col-lg-12 bx--col-md-12">
                    <FormGroup legendText="Personnel Involved*">
                      <TextArea
                        maxLength={5000}
                        labelText=""
                        id="inspector"
                        name="inspector"
                        cols={250}
                        disabled={false}
                        alt="inspectionReportActivityModel"
                        invalid={validationsActivity.inspector != null}
                        invalidText={validationsActivity.inspector}
                        light
                        placeholder=""
                        rows={4}
                        value={
                          this.state.inspectionReportActivityModel.inspector
                            ? this.state.inspectionReportActivityModel.inspector
                            : ''
                        }
                        onChange={this.handleChangeModelActivity}
                      />
                    </FormGroup>
                  </div>
                </div>
                <div className="bx--modal-content information">
                  <div className="bx--row">
                    <div className="bx--col-lg-6 bx--col-md-12 paddingTopRow">
                      <DatePicker
                        dateFormat="d/m/Y"
                        datePickerType="single"
                        id="date-picker"
                        light
                        locale="en"
                        short={false}
                        onChange={(e) => this.onActivityDateChange(e)}
                      >
                        <DatePickerInput
                          value={
                            this.state.inspectionReportActivityModel.date
                              ? moment(this.state.inspectionReportActivityModel.date).format(
                                  'DD/MM/Y'
                                )
                              : ''
                          }
                          className="some-class"
                          disabled={false}
                          iconDescription="Icon description"
                          id="date-picker-input-id"
                          invalid={validationsActivity.date != null}
                          invalidText={validationsActivity.date}
                          labelText="Activity Date*"
                          pattern="d{1,2}/d{4}"
                          placeholder="dd/mm/yyyy"
                          type="text"
                        />
                      </DatePicker>
                    </div>
                    <div className="bx--col-lg-6 bx--col-md-12">
                      <div className="bx--row">
                        <div className="bx--col-lg-6 bx--col-md-6 paddingTopRow">
                          <FormGroup key="occurrenceTime" legendText="Time From*">
                            <DateTimePicker
                              className="pickerActivity"
                              id="time-pickerFrom"
                              value={this.state.inspectionReportActivityModel.from || ''}
                              type="time"
                              placeholder="hh:mm AM/PM"
                              name="from"
                              alt="inspectionReportActivityModel"
                              invalid={validationsActivity.from != null}
                              onChange={this.updateStatesTime}
                              disabled={false}
                            />
                          </FormGroup>
                        </div>
                        <div className="bx--col-lg-6 bx--col-md-6 paddingTopRow">
                          <FormGroup key="TimeTo" legendText="Time To*">
                            <DateTimePicker
                              className="pickerActivity"
                              value={this.state.inspectionReportActivityModel.to || ''}
                              type="time"
                              placeholder="hh:mm AM/PM"
                              name="to"
                              id="time-pickerTo"
                              alt="inspectionReportActivityModel"
                              invalid={validationsActivity.to != null}
                              onChange={this.updateStatesTime}
                              disabled={false}
                            />
                          </FormGroup>
                        </div>
                        {validationsActivity.diffTIme ||
                        validationsActivity.to != null ||
                        validationsActivity.to ? (
                          <div className="srv-validation-message "> Invalid time format </div>
                        ) : null}
                        {this.state.flagTime ? (
                          <div className="srv-validation-message "> Invalid time format </div>
                        ) : null}
                      </div>
                    </div>
                  </div>

                  <div className="bx--row">
                    <div className="bx--col-lg-12 bx--col-md-12 paddingTopRow">
                      <FormGroup legendText="Activity*">
                        <TextArea
                          maxLength={5000}
                          labelText=""
                          id="activity"
                          name="activity"
                          cols={250}
                          disabled={false}
                          invalid={validationsActivity.activity != null}
                          invalidText={validationsActivity.activity}
                          light
                          placeholder=""
                          rows={4}
                          value={this.state.inspectionReportActivityModel.activity || ''}
                          onChange={this.handleChangeModelActivity}
                        />
                      </FormGroup>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button kind="secondary" onClick={() => this.showModalActivity()}>
              Cancel
            </Button>
            <Button kind="primary" onClick={() => this.addActivities()}>
              {' '}
              Save
            </Button>
          </ModalFooter>
        </ComposedModal>
      </>
    );
  }

  newDocuments() {
    const validationsDocuments = {
      name: this.validationsDocuments.message(
        'Name',
        this.state.inspectionNotificationFormDocumentModel.name,
        'required'
      ),
    };

    const modalHeader = {
      title: this.state.isUpdateDocument ? 'Edit Related Document' : 'Add new Related Document',
      iconDescription: 'Close',
      buttonOnClick: () => this.showModalDocument(),
    };

    return (
      <>
        <ComposedModal
          className="light-modal"
          open={this.state.isOpenModalDocuments}
          danger="false"
          onClose={() => false}
        >
          <ModalHeader className="margin-modal" {...modalHeader}>
            <p />
          </ModalHeader>
          <ModalBody className="margin-modal">
            <div className="bx--grid--full-width">
              <div className="bx--row">
                <div className="bx--col-lg-12 bx--col-md-12">
                  <FormGroup legendText="Name *">
                    <TextInput
                      id="name"
                      name="name"
                      placeholder="Input Name"
                      required
                      value={
                        this.state.inspectionNotificationFormDocumentModel.name
                          ? this.state.inspectionNotificationFormDocumentModel.name
                          : ''
                      }
                      onChange={this.handleChangeModelDocuments}
                      type="text"
                      labelText=""
                      className="bx--text-input  bx--text-input--light"
                      disabled={false}
                      invalid={validationsDocuments.name != null}
                    />
                  </FormGroup>
                  {validationsDocuments.name}
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button kind="secondary" onClick={() => this.showModalDocument()}>
              Cancel
            </Button>
            <Button kind="primary" onClick={() => this.addDocuments()}>
              Save
            </Button>
          </ModalFooter>
        </ComposedModal>
      </>
    );
  }

  render() {
    const headers = [
      {
        key: 'inspector',
        header: 'Personnel Involved',
        isSortable: true,
      },
      {
        key: 'activity',
        header: 'Activity',
      },
      {
        key: 'date',
        header: 'Date',
      },
      {
        key: 'from',
        header: 'Time From',
      },
      {
        key: 'to',
        header: 'Time To',
      },
    ];
    const headersDoc = [
      {
        key: 'name',
        header: 'Name',
        isSortable: true,
      },
    ];
    const activirty = this.props.activities.sort((a, b) => {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);
      const hA = moment(a.from, 'HH:mm a');
      const hB = moment(b.from, 'HH:mm a');
      dateA.setHours(hA.hours(), hA.minutes());
      dateB.setHours(hB.hours(), hB.minutes());
      return dateA - dateB;
    });
    const document = this.props.documents;

    const validationsNotifications = {
      distributionList: this.validationsNotifications.message(
        'Distribution List',
        this.state.inspectionNotificationFormModel.distributionList,
        'required'
      ),
      // responsibleEmail: this.validationsNotifications.message('Responsible Email', this.state.inspectionNotificationFormModel.responsibleEmail, 'required'),
      activitymodal: this.validationsNotifications.message(
        'Activity',
        this.state.notificationForm.activities,
        'required'
      ),

      maininformation: this.validationsNotifications.message(
        'Main informationdate ',
        this.props.inspectionModel?.inspectionReport?.startDate &&
        this.props.inspectionModel?.inspectionReport?.endDate &&
        //RITM0560302 
         (this.props.inspectionModel?.inspectionReport?.idStatus != 1 ? false : this.props.inspectionModel?.projectArea),
        'required'
      ),
      // documentsmodal: this.validationsNotifications.message('Documents', this.props.notificationForm.documents, 'required'),
    };
    return (
      <AppContext.Consumer>
        {({ user }) => (
          <>
            {validationsNotifications.maininformation ? (
              <div className="srv-validation-message">
                Enter the Project Area, startDate and endDate in the Main Information
              </div>
            ) : null}
            {this.state.mainInformationOpened ? (
              <span className="mainInformationHeaderTitleExpanded">Main Information</span>
            ) : (
              <div>
                <DataTable
                  useZebraStyles
                  rows={activirty || []}
                  headers={headers}
                  render={({ rows, getHeaderProps }) => (
                    <TableContainer>
                      <TableToolbar>
                        <TableToolbarContent className="table-toolbar-custom-content">
                          <div className="bx--col-lg-8 bx--col-md-10 table-toolbar-custon-content-info-start ">
                            <h6>List Of Inspection Activities</h6>
                          </div>
                          {!this.props.editingDisabledCheck && !this.props.inspectionModel.maskedValue && ( //RITM0946005 - Anonimizzazione Modulo Inspection
                            <div className="bx--col-lg-4 bx--col-md-2 table-toolbar-custon-content-info-end ">
                              <Button
                                onClick={this.showModalActivity}
                                kind="primary"
                                renderIcon={Add16}
                                disabled={this.props.disabled}
                                iconDescription=""
                              >
                                Add New Activity
                              </Button>
                            </div>
                          )}
                        </TableToolbarContent>
                      </TableToolbar>
                      {this.newActivity()}
                      {this.newDocuments()}
                      <Table>
                        <TableHead>
                          <TableRow>
                            {headers.map((header) => (
                              <TableHeader {...getHeaderProps({ header })}>
                                {header.header}
                              </TableHeader>
                            ))}
                            <TableHeader className="align-center">Actions</TableHeader>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {!rows || rows.length < 1 ? (
                            <NoRecordsPlaceholder
                              labelText="No Records"
                              colSpan={headers.length + 1}
                            />
                          ) : (
                            rows.map((row) => (
                              <TableRow key={`row_${row.id}`}>
                                {row.cells.map((cell) => (
                                  <TableCell key={cell.id}>
                                    {cell.info.header.includes('date')
                                      ? moment(cell.value).format('DD/MM/YYYY')
                                      : cell.info.header.includes('workSite')
                                      ? cell.value?.name || 'N/A'
                                      : cell.value}
                                  </TableCell>
                                ))}
                                <TableCell key="action" className="tableActions align-center">
                                  <div>
                                    <Button
                                      onClick={() => this.updateActivity(row.id)}
                                      size="small"
                                      renderIcon={Edit16}
                                      iconDescription="Edit"
                                      kind="ghost"
                                      disabled={this.props.disabled}
                                    />
                                    {!this.props.inspectionModel.maskedValue && ( //RITM0946005 - Anonimizzazione Modulo Inspection
                                    <Button
                                      onClick={() => this.deletedeleteActivities(row.id)}
                                      size="small"
                                      renderIcon={Delete16}
                                      iconDescription="Delete"
                                      kind="ghost"
                                      disabled={this.props.disabled}
                                    />
                                    )}
                                  </div>
                                </TableCell>
                              </TableRow>
                            ))
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                />
                {validationsNotifications.activitymodal}
                {this.props.isLoad ? <Loading /> : ''}
                <Tile light>
                  <div className="bx--col-lg-12 bx--col-md-12">
                    <FormGroup legendText="Distribution List* (Personal Email Addresses are not allowed)">
                      <EmailChips
                        id="distributionList"
                        name="distributionList"
                        title="&#9888; Do Not use Personal Accounts"

                        invalid={validationsNotifications.distributionList != null}
                        // invalidText={validations.distributionList}
                        value={
                          this.state.inspectionNotificationFormModel.distributionList
                            ? this.state.inspectionNotificationFormModel.distributionList
                            : ''
                        }
                        disabled={this.props.editingDisabledCheck}
                        type="text"
                        onChange={(value) =>
                          this.updateDistributionList(
                            'distributionList',
                            value,
                            'inspectionNotificationFormModel'
                          )
                        }
                        masked={this.props.inspectionModel.maskedValue} //RITM0946005 - Anonimizzazione Modulo Inspection
                      />
                    </FormGroup>
                    {validationsNotifications.distributionList}
                  </div>
                  <div className="bx--col-lg-12 bx--col-md-12">
                    <FormGroup legendText="Responsible persons of the inspected area/activity (Personal Email Addresses are not allowed)">
                      <EmailChips
                        id="responsibleEmail"
                        name="responsibleEmail"
                        title="&#9888; Do Not use Personal Accounts"
                        // invalid={validations.responsibleEmail != null}
                        value={
                          this.state.inspectionNotificationFormModel.responsibleEmail
                            ? this.state.inspectionNotificationFormModel.responsibleEmail
                            : ''
                        }
                        disabled={this.props.editingDisabledCheck}
                        type="text"
                        onChange={(value) =>
                          this.updateState(
                            'responsibleEmail',
                            value,
                            'inspectionNotificationFormModel'
                          )
                        }
                        masked={this.props.inspectionModel.maskedValue} //RITM0946005 - Anonimizzazione Modulo Inspection
                      />
                    </FormGroup>
                  </div>
                </Tile>
                <DataTable
                  useZebraStyles
                  rows={document}
                  headers={headersDoc}
                  render={({ rows, getHeaderProps }) => (
                    <TableContainer>
                      <TableToolbar>
                        <TableToolbarContent className="table-toolbar-custom-content">
                          <div className="bx--col-lg-8 bx--col-md-10 table-toolbar-custon-content-info-start ">
                            <h6>List Of Related Documents</h6>
                          </div>
                          {!this.props.editingDisabledCheck && (
                            <div className="bx--col-lg-4 bx--col-md-2 table-toolbar-custon-content-info-end ">
                              <Button
                                onClick={this.showModalDocument}
                                kind="primary"
                                renderIcon={Add16}
                                disabled={this.props.disabled}
                                iconDescription=""
                              >
                                Add New Document
                              </Button>
                            </div>
                          )}
                        </TableToolbarContent>
                      </TableToolbar>

                      <Table>
                        <TableHead>
                          <TableRow>
                            {headersDoc.map((header) => (
                              <TableHeader {...getHeaderProps({ header })}>
                                {header.header}
                              </TableHeader>
                            ))}
                            <TableHeader className="align-center">Actions</TableHeader>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {!rows || rows.length < 1 ? (
                            <NoRecordsPlaceholder
                              labelText="No Records"
                              colSpan={headers.length + 1}
                            />
                          ) : (
                            rows.map((row) => (
                              <TableRow key={`row_${row.id}`}>
                                {row.cells.map((cell) => (
                                  <TableCell key={cell.id}>{cell.value}</TableCell>
                                ))}
                                <TableCell key="action" className="tableActions align-center">
                                  <div>
                                    <Button
                                      onClick={() => this.updateDocuments(row.id)}
                                      size="small"
                                      renderIcon={Edit16}
                                      iconDescription="Edit"
                                      kind="ghost"
                                      disabled={this.props.disabled}
                                    />
                                    <Button
                                      onClick={() => this.deleteDocuments(row.id)}
                                      size="small"
                                      renderIcon={Delete16}
                                      iconDescription="Delete"
                                      kind="ghost"
                                      disabled={this.props.disabled}
                                    />
                                  </div>
                                </TableCell>
                              </TableRow>
                            ))
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                />

                <div className="bx--row ">
                  {(IsInRole(user, 'Administrator') || IsInRole(user, 'Compiler') || IsInRole(user, 'Data Approver')) && ( //RITM1064131
                    <div className="bx--row table-toolbar-custon-content-info-end ">
                      <Button
                        size="default"
                        renderIcon={Save16}
                        kind="secondary"
                        onClick={this.saveNotificationForm}
                        disabled={this.props.isDisabledSave}
                        iconDescription=""
                      >
                        Save
                      </Button>

                      <Button
                        size="default"
                        renderIcon={Email16}
                        kind="primary"
                        onClick={this.sendNotification}
                        iconDescription=""
                        //RITM0960566 - Inspection Report Problem Fix
                        //disabled={this.state.isDisabledSend}
                        disabled={this.props.isDisabledSendButton}
                        //End
                      >
                        Send
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            )}
          </>
        )}
      </AppContext.Consumer>
    );
  }
}
